import banner from "./../../assets/images/banner.jpg";
import jpg_laboratorio from "./../../assets/images/jpg_laboratorio_2.png";
import jpg_cine from "./../../assets/images/jpf_cine_2.png";
import "./Banner.scss";

export default function Banner({ visible }) {
  return (
    <div className="content_image_fondo">
      <div className={visible ? "bt" : ""}>
        <img src={banner} className="img_fondo" alt="" />
      </div>
      {visible && (
        <div className="images">
          <div className="row">
            <div className="col-md-6 text-center">
              <img src={jpg_laboratorio} className="img_logo" alt="" />
            </div>
            <div className="col-md-6 text-center">
              <img src={jpg_cine} className="img_logo" alt="" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
